import "./IconLoading_module.css";
const IconLoading_module = {
    spinner: "spinner__13409051e4e535c1",
    spin: "spin__13409051e4e535c1",
    dash: "dash__13409051e4e535c1"
};
export { IconLoading_module as default };
